"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ad_hok_1 = require("ad-hok");
var mapValues_1 = __importDefault(require("./utils/mapValues"));
var addExtendedHandlers = function (extendedHandlers) {
    return ad_hok_1.addHandlers(mapValues_1.default(function (extendedHandler, handlerName) { return function (props) { return function (args) {
        var existingHandler = props[handlerName] || (function () { });
        existingHandler(args);
        extendedHandler(props)(args);
    }; }; }, extendedHandlers));
};
exports.default = addExtendedHandlers;
